// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1NGpP","content":"styles_content__14i4S","selectAll":"styles_selectAll__3838B"};